import { Box, Divider, Typography } from "@mui/joy";
import { useFormContext } from "react-hook-form";
import { ShieldPlus, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "../../../../../shared";

interface ActionProps {
    api: any;
}

export default function Action({ api }: ActionProps) {
    const navigate = useNavigate();
    const {
        formState: { isValid: isFormValid, isDirty: isFormDirty },
    } = useFormContext();

    return (
        <Box mb={3}>
            <Divider sx={{ mb: 1, opacity: 0.5 }} />
            <Box display={"flex"} gap={2} mt={2}>
                <Button
                    variant={"outlined"}
                    color={"neutral"}
                    onClick={() => navigate("/admin/roles")}
                    startDecorator={<X size={18} />}
                >
                    Discard
                </Button>
                <Button
                    disabled={api.isPending || !(isFormValid && isFormDirty)}
                    type={"submit"}
                    loading={api.isPending}
                    startDecorator={<ShieldPlus size={18} />}
                    loadingPosition={"start"}
                    variant={"soft"}
                    color={"primary"}
                >
                    {api.isPending ? "Provisioning..." : "Create Role"}
                </Button>
            </Box>
        </Box>
    );
}
